import { render, staticRenderFns } from "./edition.vue?vue&type=template&id=f74c3c1c&"
import script from "./edition.vue?vue&type=script&lang=js&"
export * from "./edition.vue?vue&type=script&lang=js&"
import style0 from "./edition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports